import Vue from 'vue';
const toggle = (el, binding) => {
  Vue.nextTick(() => {
    let wrapInner = el.loadingWrapInner;
    let wrapEl = el.loadingWrapEl;
    let text = el.getAttribute('loading-text');
    if (binding.value) {
      wrapInner.innerHTML = `
        <div class="ant-spin ant-spin-spinning ant-spin-show-text">
          <span>
            <span class="ant-spin-dot ant-spin-dot-base ant-spin-dot-spin">
              <i class="ant-spin-dot-item"></i><i class="ant-spin-dot-item"></i><i class="ant-spin-dot-item"></i><i class="ant-spin-dot-item"></i>
            </span><span class="ant-spin-dot ant-spin-dot-rotate ant-spin-dot-spin">
              <i class="ant-spin-dot-item"></i><i class="ant-spin-dot-item"></i><i class="ant-spin-dot-item"></i><i class="ant-spin-dot-item"></i>
            </span>
          </span>
          ${text ? `<div class="ant-spin-text">${text}</div>` : ''}
        </div>
      `;
      wrapEl.style.display = 'block';
    } else {
      wrapInner.innerHTML = '';
      wrapEl.style.display = 'none';
    }
  });
};
const directive = {
  bind(el, binding) {
    if (!el.style.position) {
      el.style.position = 'relative';
    }
    let wrapEl = document.createElement('div');
    wrapEl.style.position = 'absolute';
    wrapEl.style.left = '0';
    wrapEl.style.top = '0';
    wrapEl.style.width = '100%';
    wrapEl.style.height = '100%';
    wrapEl.style.pointerEvents = 'none';
    wrapEl.style.background = 'rgba(255,255,255,0.3)';
    el.loadingWrapEl = wrapEl;
    let wrapInner = document.createElement('div');
    wrapInner.style.position = 'absolute';
    wrapInner.style.left = '50%';
    wrapInner.style.top = '50%';
    wrapInner.style.transform = 'translate(-50%,-50%)';
    wrapEl.appendChild(wrapInner);
    el.loadingWrapInner = wrapInner;
    el.appendChild(wrapEl);
    toggle(el, binding);
  },
  update(el, binding) {
    toggle(el, binding);
  },
  unbind(el) {
    el.loadingWrapEl && el.removeChild(el.loadingWrapEl);
  }
};
export default directive;